/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityDetailVehicleResponseDto {
    id?: string | null;
    type: ActivityDetailVehicleResponseDto.TypeEnum;
    licensePlate: string;
    licensePlateJurisdictionCode: string;
    nickname?: string | null;
}
export namespace ActivityDetailVehicleResponseDto {
    export const TypeEnum = {
        Personal: 'PERSONAL',
        Rental: 'RENTAL',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
